[
  {
    "code": "AD",
    "countryCode": 376,
    "names": {
      "de": "Andorra",
      "en": "Andorra",
      "fi": "Andorra",
      "fr": "Andorre",
      "nl": "Andorra",
      "sv": "Andorra"
    }
  },
  {
    "code": "AE",
    "countryCode": 971,
    "names": {
      "de": "Vereinigte Arabische Emirate",
      "en": "United Arab Emirates",
      "fi": "Yhdistyneet arabiemiirikunnat",
      "fr": "Émirats arabes unis",
      "nl": "Verenigde Arabische Emiraten",
      "sv": "Förenade Arabemiraten"
    }
  },
  {
    "code": "AF",
    "countryCode": 93,
    "names": {
      "de": "Afghanistan",
      "en": "Afghanistan",
      "fi": "Afghanistan",
      "fr": "Afghanistan",
      "nl": "Afghanistan",
      "sv": "Afghanistan"
    }
  },
  {
    "code": "AG",
    "countryCode": 1,
    "names": {
      "de": "Antigua und Barbuda",
      "en": "Antigua and Barbuda",
      "fi": "Antigua ja Barbuda",
      "fr": "Antigua-et-Barbuda",
      "nl": "Antigua en Barbuda",
      "sv": "Antigua och Barbuda"
    }
  },
  {
    "code": "AI",
    "countryCode": 1,
    "names": {
      "de": "Anguilla",
      "en": "Anguilla",
      "fi": "Anguilla",
      "fr": "Anguilla",
      "nl": "Anguilla",
      "sv": "Anguilla"
    }
  },
  {
    "code": "AL",
    "countryCode": 355,
    "names": {
      "de": "Albanien",
      "en": "Albania",
      "fi": "Albania",
      "fr": "Albanie",
      "nl": "Albanië",
      "sv": "Albanien"
    }
  },
  {
    "code": "AM",
    "countryCode": 374,
    "names": {
      "de": "Armenien",
      "en": "Armenia",
      "fi": "Armenia",
      "fr": "Arménie",
      "nl": "Armenië",
      "sv": "Armenien"
    }
  },
  {
    "code": "AO",
    "countryCode": 244,
    "names": {
      "de": "Angola",
      "en": "Angola",
      "fi": "Angola",
      "fr": "Angola",
      "nl": "Angola",
      "sv": "Angola"
    }
  },
  {
    "code": "AQ",
    "countryCode": 0,
    "names": {
      "de": "Antarktis",
      "en": "Antarctica",
      "fi": "Antarktis",
      "fr": "Antarctique",
      "nl": "Antarctica",
      "sv": "Antarktis"
    }
  },
  {
    "code": "AR",
    "countryCode": 54,
    "names": {
      "de": "Argentinien",
      "en": "Argentina",
      "fi": "Argentiina",
      "fr": "Argentine",
      "nl": "Argentinië",
      "sv": "Argentina"
    }
  },
  {
    "code": "AS",
    "countryCode": 1,
    "names": {
      "de": "Amerikanisch-Samoa",
      "en": "American Samoa",
      "fi": "Amerikan Samoa",
      "fr": "Samoa américaines",
      "nl": "Amerikaans Samoa",
      "sv": "Amerikanska Samoa"
    }
  },
  {
    "code": "AT",
    "countryCode": 43,
    "names": {
      "de": "Österreich",
      "en": "Austria",
      "fi": "Itävalta",
      "fr": "Autriche",
      "nl": "Oostenrijk",
      "sv": "Österrike"
    }
  },
  {
    "code": "AU",
    "countryCode": 61,
    "names": {
      "de": "Australien",
      "en": "Australia",
      "fi": "Australia",
      "fr": "Australie",
      "nl": "Australië",
      "sv": "Australien"
    }
  },
  {
    "code": "AW",
    "countryCode": 297,
    "names": {
      "de": "Aruba",
      "en": "Aruba",
      "fi": "Aruba",
      "fr": "Aruba",
      "nl": "Aruba",
      "sv": "Aruba"
    }
  },
  {
    "code": "AX",
    "countryCode": 358,
    "names": {
      "de": "Åland",
      "en": "Åland Islands",
      "fi": "Ahvenanmaa",
      "fr": "Åland",
      "nl": "Alandeilanden",
      "sv": "Åland"
    }
  },
  {
    "code": "AZ",
    "countryCode": 994,
    "names": {
      "de": "Aserbaidschan",
      "en": "Azerbaijan",
      "fi": "Azerbaidžan",
      "fr": "Azerbaïdjan",
      "nl": "Azerbeidzjan",
      "sv": "Azerbajdzjan"
    }
  },
  {
    "code": "BA",
    "countryCode": 387,
    "names": {
      "de": "Bosnien und Herzegowina",
      "en": "Bosnia and Herzegovina",
      "fi": "Bosnia-Hertsegovina",
      "fr": "Bosnie-Herzégovine",
      "nl": "Bosnië en Herzegovina",
      "sv": "Bosnien-Hercegovina"
    }
  },
  {
    "code": "BB",
    "countryCode": 1,
    "names": {
      "de": "Barbados",
      "en": "Barbados",
      "fi": "Barbados",
      "fr": "Barbade",
      "nl": "Barbados",
      "sv": "Barbados"
    }
  },
  {
    "code": "BD",
    "countryCode": 880,
    "names": {
      "de": "Bangladesch",
      "en": "Bangladesh",
      "fi": "Bangladesh",
      "fr": "Bangladesh",
      "nl": "Bangladesh",
      "sv": "Bangladesh"
    }
  },
  {
    "code": "BE",
    "countryCode": 32,
    "names": {
      "de": "Belgien",
      "en": "Belgium",
      "fi": "Belgia",
      "fr": "Belgique",
      "nl": "België",
      "sv": "Belgien"
    }
  },
  {
    "code": "BF",
    "countryCode": 226,
    "names": {
      "de": "Burkina Faso",
      "en": "Burkina Faso",
      "fi": "Burkina Faso",
      "fr": "Burkina Faso",
      "nl": "Burkina Faso",
      "sv": "Burkina Faso"
    }
  },
  {
    "code": "BG",
    "countryCode": 359,
    "names": {
      "de": "Bulgarien",
      "en": "Bulgaria",
      "fi": "Bulgaria",
      "fr": "Bulgarie",
      "nl": "Bulgarije",
      "sv": "Bulgarien"
    }
  },
  {
    "code": "BH",
    "countryCode": 973,
    "names": {
      "de": "Bahrain",
      "en": "Bahrain",
      "fi": "Bahrain",
      "fr": "Bahreïn",
      "nl": "Bahrein",
      "sv": "Bahrain"
    }
  },
  {
    "code": "BI",
    "countryCode": 257,
    "names": {
      "de": "Burundi",
      "en": "Burundi",
      "fi": "Burundi",
      "fr": "Burundi",
      "nl": "Burundi",
      "sv": "Burundi"
    }
  },
  {
    "code": "BJ",
    "countryCode": 229,
    "names": {
      "de": "Benin",
      "en": "Benin",
      "fi": "Benin",
      "fr": "Bénin",
      "nl": "Benin",
      "sv": "Benin"
    }
  },
  {
    "code": "BL",
    "countryCode": 590,
    "names": {
      "de": "Saint-Barthélemy",
      "en": "Saint Barthélemy",
      "fi": "Saint Barthélemy",
      "fr": "Saint-Barthélemy",
      "nl": "Saint Barthélemy",
      "sv": "Saint-Barthélemy"
    }
  },
  {
    "code": "BM",
    "countryCode": 1,
    "names": {
      "de": "Bermuda",
      "en": "Bermuda",
      "fi": "Bermuda",
      "fr": "Bermudes",
      "nl": "Bermuda",
      "sv": "Bermuda"
    }
  },
  {
    "code": "BN",
    "countryCode": 673,
    "names": {
      "de": "Brunei Darussalam",
      "en": "Brunei Darussalam",
      "fi": "Brunei Darussalamin valtio",
      "fr": "Brunei",
      "nl": "Brunei",
      "sv": "Brunei"
    }
  },
  {
    "code": "BO",
    "countryCode": 591,
    "names": {
      "de": "Bolivien",
      "en": "Bolivia, Plurinational State of",
      "fi": "Bolivia, monikansallinen valtio",
      "fr": "Bolivie",
      "nl": "Bolivia",
      "sv": "Bolivia, Mångnationella staten"
    }
  },
  {
    "code": "BQ",
    "countryCode": 599,
    "names": {
      "de": "Bonaire, Sint Eustatius und Saba",
      "en": "Bonaire, Sint Eustatius and Saba",
      "fi": "Bonaire, Sint Eustatius ja Saba",
      "fr": "Pays-Bas caribéens",
      "nl": "Bonaire, Sint Eustatius en Saba",
      "sv": "Bonaire, Sint Eustatius och Saba"
    }
  },
  {
    "code": "BR",
    "countryCode": 55,
    "names": {
      "de": "Brasilien",
      "en": "Brazil",
      "fi": "Brasilia",
      "fr": "Brésil",
      "nl": "Brazilië",
      "sv": "Brasilien"
    }
  },
  {
    "code": "BS",
    "countryCode": 1,
    "names": {
      "de": "Bahamas",
      "en": "Bahamas",
      "fi": "Bahama",
      "fr": "Bahamas",
      "nl": "Bahama’s",
      "sv": "Bahamas"
    }
  },
  {
    "code": "BT",
    "countryCode": 975,
    "names": {
      "de": "Bhutan",
      "en": "Bhutan",
      "fi": "Bhutan",
      "fr": "Bhoutan",
      "nl": "Bhutan",
      "sv": "Bhutan"
    }
  },
  {
    "code": "BV",
    "countryCode": 0,
    "names": {
      "de": "Bouvetinsel",
      "en": "Bouvet Island",
      "fi": "Bouvet'nsaari",
      "fr": "Île Bouvet",
      "nl": "Bouveteiland",
      "sv": "Bouvetön"
    }
  },
  {
    "code": "BW",
    "countryCode": 267,
    "names": {
      "de": "Botswana",
      "en": "Botswana",
      "fi": "Botswana",
      "fr": "Botswana",
      "nl": "Botswana",
      "sv": "Botswana"
    }
  },
  {
    "code": "BY",
    "countryCode": 375,
    "names": {
      "de": "Belarus (Weißrussland)",
      "en": "Belarus",
      "fi": "Valko-Venäjä",
      "fr": "Biélorussie",
      "nl": "Wit-Rusland",
      "sv": "Vitryssland"
    }
  },
  {
    "code": "BZ",
    "countryCode": 501,
    "names": {
      "de": "Belize",
      "en": "Belize",
      "fi": "Belize",
      "fr": "Bélize",
      "nl": "Belize",
      "sv": "Belize"
    }
  },
  {
    "code": "CA",
    "countryCode": 1,
    "names": {
      "de": "Kanada",
      "en": "Canada",
      "fi": "Kanada",
      "fr": "Canada",
      "nl": "Canada",
      "sv": "Kanada"
    }
  },
  {
    "code": "CC",
    "countryCode": 61,
    "names": {
      "de": "Kokosinseln",
      "en": "Cocos (Keeling) Islands",
      "fi": "Kookossaaret",
      "fr": "Îles Cocos",
      "nl": "Cocoseilanden (Keelingeilanden)",
      "sv": "Kokosöarna"
    }
  },
  {
    "code": "CD",
    "countryCode": 243,
    "names": {
      "de": "Kongo, Demokratische Republik (ehem. Zaire)",
      "en": "Congo, The Democratic Republic of the",
      "fi": "Kongon demokraattinen tasavalta",
      "fr": "République démocratique du Congo",
      "nl": "Congo-Kinshasa",
      "sv": "Kongo, demokratiska republiken"
    }
  },
  {
    "code": "CF",
    "countryCode": 236,
    "names": {
      "de": "Zentralafrikanische Republik",
      "en": "Central African Republic",
      "fi": "Keski-Afrikan tasavalta",
      "fr": "République centrafricaine",
      "nl": "Centraal-Afrikaanse Republiek",
      "sv": "Centralafrikanska republiken"
    }
  },
  {
    "code": "CG",
    "countryCode": 242,
    "names": {
      "de": "Republik Kongo",
      "en": "Congo",
      "fi": "Kongo",
      "fr": "Congo",
      "nl": "Congo",
      "sv": "Kongo"
    }
  },
  {
    "code": "CH",
    "countryCode": 41,
    "names": {
      "de": "Schweiz",
      "en": "Switzerland",
      "fi": "Sveitsi",
      "fr": "Suisse",
      "nl": "Zwitserland",
      "sv": "Schweiz"
    }
  },
  {
    "code": "CI",
    "countryCode": 225,
    "names": {
      "de": "Côte d'Ivoire (Elfenbeinküste)",
      "en": "Côte d'Ivoire",
      "fi": "Norsunluurannikko",
      "fr": "Côte d'Ivoire",
      "nl": "Ivoorkust",
      "sv": "Elfenbenskusten"
    }
  },
  {
    "code": "CK",
    "countryCode": 682,
    "names": {
      "de": "Cookinseln",
      "en": "Cook Islands",
      "fi": "Cookinsaaret",
      "fr": "Îles Cook",
      "nl": "Cookeilanden",
      "sv": "Cooköarna"
    }
  },
  {
    "code": "CL",
    "countryCode": 56,
    "names": {
      "de": "Chile",
      "en": "Chile",
      "fi": "Chile",
      "fr": "Chili",
      "nl": "Chili",
      "sv": "Chile"
    }
  },
  {
    "code": "CM",
    "countryCode": 237,
    "names": {
      "de": "Kamerun",
      "en": "Cameroon",
      "fi": "Kamerun",
      "fr": "Cameroun",
      "nl": "Kameroen",
      "sv": "Kamerun"
    }
  },
  {
    "code": "CN",
    "countryCode": 86,
    "names": {
      "de": "China, Volksrepublik",
      "en": "China",
      "fi": "Kiina",
      "fr": "Chine",
      "nl": "China",
      "sv": "Kina"
    }
  },
  {
    "code": "CO",
    "countryCode": 57,
    "names": {
      "de": "Kolumbien",
      "en": "Colombia",
      "fi": "Kolumbia",
      "fr": "Colombie",
      "nl": "Colombia",
      "sv": "Colombia"
    }
  },
  {
    "code": "CR",
    "countryCode": 506,
    "names": {
      "de": "Costa Rica",
      "en": "Costa Rica",
      "fi": "Costa Rica",
      "fr": "Costa Rica",
      "nl": "Costa Rica",
      "sv": "Costa Rica"
    }
  },
  {
    "code": "CU",
    "countryCode": 53,
    "names": { "de": "Kuba", "en": "Cuba", "fi": "Kuuba", "fr": "Cuba", "nl": "Cuba", "sv": "Kuba" }
  },
  {
    "code": "CV",
    "countryCode": 238,
    "names": {
      "de": "Kap Verde",
      "en": "Cabo Verde",
      "fi": "Kap Verde",
      "fr": "Cap-Vert",
      "nl": "Kaapverdië",
      "sv": "Kap Verde"
    }
  },
  {
    "code": "CW",
    "countryCode": 599,
    "names": {
      "de": "Curaçao",
      "en": "Curaçao",
      "fi": "Curaçao",
      "fr": "Curaçao",
      "nl": "Curaçao",
      "sv": "Curaçao"
    }
  },
  {
    "code": "CX",
    "countryCode": 61,
    "names": {
      "de": "Weihnachtsinsel",
      "en": "Christmas Island",
      "fi": "Joulusaari",
      "fr": "Île Christmas (Australie)",
      "nl": "Christmaseiland",
      "sv": "Julön"
    }
  },
  {
    "code": "CY",
    "countryCode": 357,
    "names": {
      "de": "Zypern",
      "en": "Cyprus",
      "fi": "Kypros",
      "fr": "Chypre",
      "nl": "Cyprus",
      "sv": "Cypern"
    }
  },
  {
    "code": "CZ",
    "countryCode": 420,
    "names": {
      "de": "Tschechien",
      "en": "Czechia",
      "fi": "Czechia",
      "fr": "Tchéquie",
      "nl": "Tsjechië",
      "sv": "Tjeckien"
    }
  },
  {
    "code": "DE",
    "countryCode": 49,
    "names": {
      "de": "Deutschland",
      "en": "Germany",
      "fi": "Saksa",
      "fr": "Allemagne",
      "nl": "Duitsland",
      "sv": "Tyskland"
    }
  },
  {
    "code": "DJ",
    "countryCode": 253,
    "names": {
      "de": "Dschibuti",
      "en": "Djibouti",
      "fi": "Djibouti",
      "fr": "Djibouti",
      "nl": "Djibouti",
      "sv": "Djibouti"
    }
  },
  {
    "code": "DK",
    "countryCode": 45,
    "names": {
      "de": "Dänemark",
      "en": "Denmark",
      "fi": "Tanska",
      "fr": "Danemark",
      "nl": "Denemarken",
      "sv": "Danmark"
    }
  },
  {
    "code": "DM",
    "countryCode": 1,
    "names": {
      "de": "Dominica",
      "en": "Dominica",
      "fi": "Dominica",
      "fr": "Dominique",
      "nl": "Dominica",
      "sv": "Dominica"
    }
  },
  {
    "code": "DO",
    "countryCode": 1,
    "names": {
      "de": "Dominikanische Republik",
      "en": "Dominican Republic",
      "fi": "Dominikaaninen tasavalta",
      "fr": "République dominicaine",
      "nl": "Dominicaanse Republiek",
      "sv": "Dominikanska republiken"
    }
  },
  {
    "code": "DZ",
    "countryCode": 213,
    "names": {
      "de": "Algerien",
      "en": "Algeria",
      "fi": "Algeria",
      "fr": "Algérie",
      "nl": "Algerije",
      "sv": "Algeriet"
    }
  },
  {
    "code": "EC",
    "countryCode": 593,
    "names": {
      "de": "Ecuador",
      "en": "Ecuador",
      "fi": "Ecuador",
      "fr": "Équateur",
      "nl": "Ecuador",
      "sv": "Ecuador"
    }
  },
  {
    "code": "EE",
    "countryCode": 372,
    "names": {
      "de": "Estland",
      "en": "Estonia",
      "fi": "Viro",
      "fr": "Estonie",
      "nl": "Estland",
      "sv": "Estland"
    }
  },
  {
    "code": "EG",
    "countryCode": 20,
    "names": {
      "de": "Ägypten",
      "en": "Egypt",
      "fi": "Egypti",
      "fr": "Égypte",
      "nl": "Egypte",
      "sv": "Egypten"
    }
  },
  {
    "code": "EH",
    "countryCode": 212,
    "names": {
      "de": "Westsahara",
      "en": "Western Sahara",
      "fi": "Länsi-Sahara",
      "fr": "Sahara occidental",
      "nl": "Westelijke Sahara",
      "sv": "Västsahara"
    }
  },
  {
    "code": "ER",
    "countryCode": 291,
    "names": {
      "de": "Eritrea",
      "en": "Eritrea",
      "fi": "Eritrea",
      "fr": "Érythrée",
      "nl": "Eritrea",
      "sv": "Eritrea"
    }
  },
  {
    "code": "ES",
    "countryCode": 34,
    "names": {
      "de": "Spanien",
      "en": "Spain",
      "fi": "Espanja",
      "fr": "Espagne",
      "nl": "Spanje",
      "sv": "Spanien"
    }
  },
  {
    "code": "ET",
    "countryCode": 251,
    "names": {
      "de": "Äthiopien",
      "en": "Ethiopia",
      "fi": "Etiopia",
      "fr": "Éthiopie",
      "nl": "Ethiopië",
      "sv": "Etiopien"
    }
  },
  {
    "code": "FI",
    "countryCode": 358,
    "names": {
      "de": "Finnland",
      "en": "Finland",
      "fi": "Suomi",
      "fr": "Finlande",
      "nl": "Finland",
      "sv": "Finland"
    }
  },
  {
    "code": "FJ",
    "countryCode": 679,
    "names": {
      "de": "Fidschi",
      "en": "Fiji",
      "fi": "Fidži",
      "fr": "Fidji",
      "nl": "Fiji",
      "sv": "Fiji"
    }
  },
  {
    "code": "FK",
    "countryCode": 500,
    "names": {
      "de": "Falklandinseln",
      "en": "Falkland Islands (Malvinas)",
      "fi": "Falklandinsaaret",
      "fr": "Îles Malouines",
      "nl": "Falklandeilanden (Malvinas)",
      "sv": "Falklandsöarna (Malvinas)"
    }
  },
  {
    "code": "FM",
    "countryCode": 691,
    "names": {
      "de": "Mikronesien",
      "en": "Micronesia, Federated States of",
      "fi": "Mikronesian liittovaltio",
      "fr": "Micronésie",
      "nl": "Micronesië",
      "sv": "Mikronesien, federala staterna"
    }
  },
  {
    "code": "FO",
    "countryCode": 298,
    "names": {
      "de": "Färöer",
      "en": "Faroe Islands",
      "fi": "Färsaaret",
      "fr": "Îles Féroé",
      "nl": "Faeröer",
      "sv": "Färöarna"
    }
  },
  {
    "code": "FR",
    "countryCode": 33,
    "names": {
      "de": "Frankreich",
      "en": "France",
      "fi": "Ranska",
      "fr": "France",
      "nl": "Frankrijk",
      "sv": "Frankrike"
    }
  },
  {
    "code": "GA",
    "countryCode": 241,
    "names": {
      "de": "Gabun",
      "en": "Gabon",
      "fi": "Gabon",
      "fr": "Gabon",
      "nl": "Gabon",
      "sv": "Gabon"
    }
  },
  {
    "code": "GB",
    "countryCode": 44,
    "names": {
      "de": "Vereinigtes Königreich",
      "en": "United Kingdom",
      "fi": "Yhdistynyt kuningaskunta",
      "fr": "Royaume-Uni",
      "nl": "Verenigd Koninkrijk",
      "sv": "Förenade kungariket"
    }
  },
  {
    "code": "GD",
    "countryCode": 1,
    "names": {
      "de": "Grenada",
      "en": "Grenada",
      "fi": "Grenada",
      "fr": "Grenade",
      "nl": "Grenada",
      "sv": "Grenada"
    }
  },
  {
    "code": "GE",
    "countryCode": 995,
    "names": {
      "de": "Georgien",
      "en": "Georgia",
      "fi": "Georgia",
      "fr": "Géorgie",
      "nl": "Georgië",
      "sv": "Georgien"
    }
  },
  {
    "code": "GF",
    "countryCode": 594,
    "names": {
      "de": "Französisch-Guayana",
      "en": "French Guiana",
      "fi": "Ranskan Guayana",
      "fr": "Guyane",
      "nl": "Frans-Guyana",
      "sv": "Franska Guyana"
    }
  },
  {
    "code": "GG",
    "countryCode": 44,
    "names": {
      "de": "Guernsey (Kanalinsel)",
      "en": "Guernsey",
      "fi": "Guernsey",
      "fr": "Guernesey",
      "nl": "Guernsey",
      "sv": "Guernsey"
    }
  },
  {
    "code": "GH",
    "countryCode": 233,
    "names": {
      "de": "Ghana",
      "en": "Ghana",
      "fi": "Ghana",
      "fr": "Ghana",
      "nl": "Ghana",
      "sv": "Ghana"
    }
  },
  {
    "code": "GI",
    "countryCode": 350,
    "names": {
      "de": "Gibraltar",
      "en": "Gibraltar",
      "fi": "Gibraltar",
      "fr": "Gibraltar",
      "nl": "Gibraltar",
      "sv": "Gibraltar"
    }
  },
  {
    "code": "GL",
    "countryCode": 299,
    "names": {
      "de": "Grönland",
      "en": "Greenland",
      "fi": "Grönlanti",
      "fr": "Groenland",
      "nl": "Groenland",
      "sv": "Grönland"
    }
  },
  {
    "code": "GM",
    "countryCode": 220,
    "names": {
      "de": "Gambia",
      "en": "Gambia",
      "fi": "Gambia",
      "fr": "Gambie",
      "nl": "Gambia",
      "sv": "Gambia"
    }
  },
  {
    "code": "GN",
    "countryCode": 224,
    "names": {
      "de": "Guinea",
      "en": "Guinea",
      "fi": "Guinea",
      "fr": "Guinée",
      "nl": "Guinee",
      "sv": "Guinea"
    }
  },
  {
    "code": "GP",
    "countryCode": 590,
    "names": {
      "de": "Guadeloupe",
      "en": "Guadeloupe",
      "fi": "Guadeloupe",
      "fr": "Guadeloupe",
      "nl": "Guadeloupe",
      "sv": "Guadeloupe"
    }
  },
  {
    "code": "GQ",
    "countryCode": 240,
    "names": {
      "de": "Äquatorialguinea",
      "en": "Equatorial Guinea",
      "fi": "Päiväntasaajan Guinea",
      "fr": "Guinée équatoriale",
      "nl": "Equatoriaal-Guinea",
      "sv": "Ekvatorialguinea"
    }
  },
  {
    "code": "GR",
    "countryCode": 30,
    "names": {
      "de": "Griechenland",
      "en": "Greece",
      "fi": "Kreikka",
      "fr": "Grèce",
      "nl": "Griekenland",
      "sv": "Grekland"
    }
  },
  {
    "code": "GS",
    "countryCode": 0,
    "names": {
      "de": "Südgeorgien und die Südlichen Sandwichinseln",
      "en": "South Georgia and the South Sandwich Islands",
      "fi": "Etelä-Georgia ja Eteläiset Sandwichinsaaret",
      "fr": "Géorgie du Sud-et-les Îles Sandwich du Sud",
      "nl": "Zuid-Georgië en Zuidelijke Sandwicheilanden",
      "sv": "Sydgeorgien och södra Sandwichöarna"
    }
  },
  {
    "code": "GT",
    "countryCode": 502,
    "names": {
      "de": "Guatemala",
      "en": "Guatemala",
      "fi": "Guatemala",
      "fr": "Guatemala",
      "nl": "Guatemala",
      "sv": "Guatemala"
    }
  },
  {
    "code": "GU",
    "countryCode": 1,
    "names": { "de": "Guam", "en": "Guam", "fi": "Guam", "fr": "Guam", "nl": "Guam", "sv": "Guam" }
  },
  {
    "code": "GW",
    "countryCode": 245,
    "names": {
      "de": "Guinea-Bissau",
      "en": "Guinea-Bissau",
      "fi": "Guinea-Bissau",
      "fr": "Guinée-Bissau",
      "nl": "Guinee-Bissau",
      "sv": "Guinea-Bissau"
    }
  },
  {
    "code": "GY",
    "countryCode": 592,
    "names": {
      "de": "Guyana",
      "en": "Guyana",
      "fi": "Guyana",
      "fr": "Guyana",
      "nl": "Guyana",
      "sv": "Guyana"
    }
  },
  {
    "code": "HK",
    "countryCode": 852,
    "names": {
      "de": "Hongkong",
      "en": "Hong Kong",
      "fi": "Hong Kong",
      "fr": "Hong Kong",
      "nl": "Hongkong",
      "sv": "Hongkong"
    }
  },
  {
    "code": "HM",
    "countryCode": 0,
    "names": {
      "de": "Heard und McDonaldinseln",
      "en": "Heard Island and McDonald Islands",
      "fi": "Heard ja McDonaldinsaaret",
      "fr": "Îles Heard-et-MacDonald",
      "nl": "Heard- en McDonaldeilanden",
      "sv": "Heardön och McDonaldöarna"
    }
  },
  {
    "code": "HN",
    "countryCode": 504,
    "names": {
      "de": "Honduras",
      "en": "Honduras",
      "fi": "Honduras",
      "fr": "Honduras",
      "nl": "Honduras",
      "sv": "Honduras"
    }
  },
  {
    "code": "HR",
    "countryCode": 385,
    "names": {
      "de": "Kroatien",
      "en": "Croatia",
      "fi": "Kroatia",
      "fr": "Croatie",
      "nl": "Kroatië",
      "sv": "Kroatien"
    }
  },
  {
    "code": "HT",
    "countryCode": 509,
    "names": {
      "de": "Haiti",
      "en": "Haiti",
      "fi": "Haiti",
      "fr": "Haïti",
      "nl": "Haïti",
      "sv": "Haiti"
    }
  },
  {
    "code": "HU",
    "countryCode": 36,
    "names": {
      "de": "Ungarn",
      "en": "Hungary",
      "fi": "Unkari",
      "fr": "Hongrie",
      "nl": "Hongarije",
      "sv": "Ungern"
    }
  },
  {
    "code": "ID",
    "countryCode": 62,
    "names": {
      "de": "Indonesien",
      "en": "Indonesia",
      "fi": "Indonesia",
      "fr": "Indonésie",
      "nl": "Indonesië",
      "sv": "Indonesien"
    }
  },
  {
    "code": "IE",
    "countryCode": 353,
    "names": {
      "de": "Irland",
      "en": "Ireland",
      "fi": "Irlanti",
      "fr": "Irlande",
      "nl": "Ierland",
      "sv": "Irland"
    }
  },
  {
    "code": "IL",
    "countryCode": 972,
    "names": {
      "de": "Israel",
      "en": "Israel",
      "fi": "Israel",
      "fr": "Israël",
      "nl": "Israël",
      "sv": "Israel"
    }
  },
  {
    "code": "IM",
    "countryCode": 44,
    "names": {
      "de": "Insel Man",
      "en": "Isle of Man",
      "fi": "Mansaari",
      "fr": "Île de Man",
      "nl": "Isle of Man",
      "sv": "Isle of Man"
    }
  },
  {
    "code": "IN",
    "countryCode": 91,
    "names": {
      "de": "Indien",
      "en": "India",
      "fi": "Intia",
      "fr": "Inde",
      "nl": "India",
      "sv": "Indien"
    }
  },
  {
    "code": "IO",
    "countryCode": 246,
    "names": {
      "de": "Britisches Territorium im Indischen Ozean",
      "en": "British Indian Ocean Territory",
      "fi": "Brittiläinen Intian valtameren alue",
      "fr": "Territoire britannique de l'océan Indien",
      "nl": "Britse Gebieden in de Indische Oceaan",
      "sv": "Brittiskt territorium i Indiska Oceanen"
    }
  },
  {
    "code": "IQ",
    "countryCode": 964,
    "names": { "de": "Irak", "en": "Iraq", "fi": "Irak", "fr": "Irak", "nl": "Irak", "sv": "Irak" }
  },
  {
    "code": "IR",
    "countryCode": 98,
    "names": {
      "de": "Iran, Islamische Republik",
      "en": "Iran, Islamic Republic of",
      "fi": "Iranin islamilainen tasavalta",
      "fr": "Iran",
      "nl": "Iran",
      "sv": "Iran, islamiska republiken"
    }
  },
  {
    "code": "IS",
    "countryCode": 354,
    "names": {
      "de": "Island",
      "en": "Iceland",
      "fi": "Islanti",
      "fr": "Islande",
      "nl": "IJsland",
      "sv": "Island"
    }
  },
  {
    "code": "IT",
    "countryCode": 39,
    "names": {
      "de": "Italien",
      "en": "Italy",
      "fi": "Italia",
      "fr": "Italie",
      "nl": "Italië",
      "sv": "Italien"
    }
  },
  {
    "code": "JE",
    "countryCode": 44,
    "names": {
      "de": "Jersey (Kanalinsel)",
      "en": "Jersey",
      "fi": "Jersey",
      "fr": "Jersey",
      "nl": "Jersey",
      "sv": "Jersey"
    }
  },
  {
    "code": "JM",
    "countryCode": 1,
    "names": {
      "de": "Jamaika",
      "en": "Jamaica",
      "fi": "Jamaika",
      "fr": "Jamaïque",
      "nl": "Jamaica",
      "sv": "Jamaica"
    }
  },
  {
    "code": "JO",
    "countryCode": 962,
    "names": {
      "de": "Jordanien",
      "en": "Jordan",
      "fi": "Jordania",
      "fr": "Jordanie",
      "nl": "Jordanië",
      "sv": "Jordanien"
    }
  },
  {
    "code": "JP",
    "countryCode": 81,
    "names": {
      "de": "Japan",
      "en": "Japan",
      "fi": "Japani",
      "fr": "Japon",
      "nl": "Japan",
      "sv": "Japan"
    }
  },
  {
    "code": "KE",
    "countryCode": 254,
    "names": {
      "de": "Kenia",
      "en": "Kenya",
      "fi": "Kenia",
      "fr": "Kenya",
      "nl": "Kenia",
      "sv": "Kenya"
    }
  },
  {
    "code": "KG",
    "countryCode": 996,
    "names": {
      "de": "Kirgisistan",
      "en": "Kyrgyzstan",
      "fi": "Kirgisia",
      "fr": "Kirghizistan",
      "nl": "Kirgizië",
      "sv": "Kirgizistan"
    }
  },
  {
    "code": "KH",
    "countryCode": 855,
    "names": {
      "de": "Kambodscha",
      "en": "Cambodia",
      "fi": "Kambodža",
      "fr": "Cambodge",
      "nl": "Cambodja",
      "sv": "Kambodja"
    }
  },
  {
    "code": "KI",
    "countryCode": 686,
    "names": {
      "de": "Kiribati",
      "en": "Kiribati",
      "fi": "Kiribati",
      "fr": "Kiribati",
      "nl": "Kiribati",
      "sv": "Kiribati"
    }
  },
  {
    "code": "KM",
    "countryCode": 269,
    "names": {
      "de": "Komoren",
      "en": "Comoros",
      "fi": "Komorit",
      "fr": "Comores",
      "nl": "Comoren",
      "sv": "Comorerna"
    }
  },
  {
    "code": "KN",
    "countryCode": 1,
    "names": {
      "de": "St. Kitts und Nevis",
      "en": "Saint Kitts and Nevis",
      "fi": "Saint Kitts ja Nevis",
      "fr": "Saint-Christophe-et-Niévès",
      "nl": "Saint Kitts en Nevis",
      "sv": "Sankt Kitts och Nevis"
    }
  },
  {
    "code": "KP",
    "countryCode": 850,
    "names": {
      "de": "Korea, Demokratische Volksrepublik (Nordkorea)",
      "en": "Korea, Democratic People's Republic of",
      "fi": "Korean demokraattinen kansantasavalta",
      "fr": "Corée du Nord",
      "nl": "Korea, Democratische Volksrepubliek",
      "sv": "Korea, demokratiska folkrepubliken"
    }
  },
  {
    "code": "KR",
    "countryCode": 82,
    "names": {
      "de": "Korea, Republik (Südkorea)",
      "en": "Korea, Republic of",
      "fi": "Korean tasavalta",
      "fr": "Corée du Sud",
      "nl": "Korea, Republiek",
      "sv": "Sydkorea"
    }
  },
  {
    "code": "KW",
    "countryCode": 965,
    "names": {
      "de": "Kuwait",
      "en": "Kuwait",
      "fi": "Kuwait",
      "fr": "Koweït",
      "nl": "Koeweit",
      "sv": "Kuwait"
    }
  },
  {
    "code": "KY",
    "countryCode": 1,
    "names": {
      "de": "Kaimaninseln",
      "en": "Cayman Islands",
      "fi": "Caymansaaret",
      "fr": "Îles Caïmans",
      "nl": "Caymaneilanden",
      "sv": "Caymanöarna"
    }
  },
  {
    "code": "KZ",
    "countryCode": 7,
    "names": {
      "de": "Kasachstan",
      "en": "Kazakhstan",
      "fi": "Kazakstan",
      "fr": "Kazakhstan",
      "nl": "Kazachstan",
      "sv": "Kazakstan"
    }
  },
  {
    "code": "LA",
    "countryCode": 856,
    "names": {
      "de": "Laos, Demokratische Volksrepublik",
      "en": "Lao People's Democratic Republic",
      "fi": "Laos",
      "fr": "Laos",
      "nl": "Laos",
      "sv": "Demokratiska folkrepubliken Lao"
    }
  },
  {
    "code": "LB",
    "countryCode": 961,
    "names": {
      "de": "Libanon",
      "en": "Lebanon",
      "fi": "Libanon",
      "fr": "Liban",
      "nl": "Libanon",
      "sv": "Libanon"
    }
  },
  {
    "code": "LC",
    "countryCode": 1,
    "names": {
      "de": "St. Lucia",
      "en": "Saint Lucia",
      "fi": "Saint Lucia",
      "fr": "Sainte-Lucie",
      "nl": "Saint Lucia",
      "sv": "Sankt Lucia"
    }
  },
  {
    "code": "LI",
    "countryCode": 423,
    "names": {
      "de": "Liechtenstein",
      "en": "Liechtenstein",
      "fi": "Liechtenstein",
      "fr": "Liechtenstein",
      "nl": "Liechtenstein",
      "sv": "Liechtenstein"
    }
  },
  {
    "code": "LK",
    "countryCode": 94,
    "names": {
      "de": "Sri Lanka",
      "en": "Sri Lanka",
      "fi": "Sri Lanka",
      "fr": "Sri Lanka",
      "nl": "Sri Lanka",
      "sv": "Sri Lanka"
    }
  },
  {
    "code": "LR",
    "countryCode": 231,
    "names": {
      "de": "Liberia",
      "en": "Liberia",
      "fi": "Liberia",
      "fr": "Liberia",
      "nl": "Liberia",
      "sv": "Liberia"
    }
  },
  {
    "code": "LS",
    "countryCode": 266,
    "names": {
      "de": "Lesotho",
      "en": "Lesotho",
      "fi": "Lesotho",
      "fr": "Lesotho",
      "nl": "Lesotho",
      "sv": "Lesotho"
    }
  },
  {
    "code": "LT",
    "countryCode": 370,
    "names": {
      "de": "Litauen",
      "en": "Lithuania",
      "fi": "Liettua",
      "fr": "Lituanie",
      "nl": "Litouwen",
      "sv": "Litauen"
    }
  },
  {
    "code": "LU",
    "countryCode": 352,
    "names": {
      "de": "Luxemburg",
      "en": "Luxembourg",
      "fi": "Luxemburg",
      "fr": "Luxembourg",
      "nl": "Luxemburg",
      "sv": "Luxemburg"
    }
  },
  {
    "code": "LV",
    "countryCode": 371,
    "names": {
      "de": "Lettland",
      "en": "Latvia",
      "fi": "Latvia",
      "fr": "Lettonie",
      "nl": "Letland",
      "sv": "Lettland"
    }
  },
  {
    "code": "LY",
    "countryCode": 218,
    "names": {
      "de": "Libysch-Arabische Dschamahirija (Libyen)",
      "en": "Libya",
      "fi": "Libya",
      "fr": "Libye",
      "nl": "Libië",
      "sv": "Libyen"
    }
  },
  {
    "code": "MA",
    "countryCode": 212,
    "names": {
      "de": "Marokko",
      "en": "Morocco",
      "fi": "Marokko",
      "fr": "Maroc",
      "nl": "Marokko",
      "sv": "Marocko"
    }
  },
  {
    "code": "MC",
    "countryCode": 377,
    "names": {
      "de": "Monaco",
      "en": "Monaco",
      "fi": "Monaco",
      "fr": "Monaco",
      "nl": "Monaco",
      "sv": "Monaco"
    }
  },
  {
    "code": "MD",
    "countryCode": 373,
    "names": {
      "de": "Moldawien (Republik Moldau)",
      "en": "Moldova, Republic of",
      "fi": "Moldovan tasavalta",
      "fr": "Moldovie",
      "nl": "Moldavië",
      "sv": "Moldavien, republiken"
    }
  },
  {
    "code": "ME",
    "countryCode": 382,
    "names": {
      "de": "Montenegro",
      "en": "Montenegro",
      "fi": "Montenegro",
      "fr": "Monténégro",
      "nl": "Montenegro",
      "sv": "Montenegro"
    }
  },
  {
    "code": "MF",
    "countryCode": 590,
    "names": {
      "de": "Saint-Martin (franz. Teil)",
      "en": "Saint Martin (French part)",
      "fi": "Saint-Martin (ranskalainen osa)",
      "fr": "Saint-Martin (Antilles françaises)",
      "nl": "Sint-Maarten (Frans deel)",
      "sv": "Saint Martin (franska delen)"
    }
  },
  {
    "code": "MG",
    "countryCode": 261,
    "names": {
      "de": "Madagaskar",
      "en": "Madagascar",
      "fi": "Madagaskar",
      "fr": "Malgache",
      "nl": "Madagaskar",
      "sv": "Madagaskar"
    }
  },
  {
    "code": "MH",
    "countryCode": 692,
    "names": {
      "de": "Marshallinseln",
      "en": "Marshall Islands",
      "fi": "Marshallinsaaret",
      "fr": "Îles Marshall",
      "nl": "Marshalleilanden",
      "sv": "Marshallöarna"
    }
  },
  {
    "code": "MK",
    "countryCode": 389,
    "names": {
      "de": "Nordmazedonien",
      "en": "North Macedonia",
      "fi": "Pohjois-Makedonia",
      "fr": "Macédoine du Nord",
      "nl": "Noord-Macedonië",
      "sv": "Nordmakedonien"
    }
  },
  {
    "code": "ML",
    "countryCode": 223,
    "names": { "de": "Mali", "en": "Mali", "fi": "Mali", "fr": "Mali", "nl": "Mali", "sv": "Mali" }
  },
  {
    "code": "MM",
    "countryCode": 95,
    "names": {
      "de": "Myanmar (Burma)",
      "en": "Myanmar",
      "fi": "Myanmar",
      "fr": "Myanmar",
      "nl": "Myanmar",
      "sv": "Myanmar"
    }
  },
  {
    "code": "MN",
    "countryCode": 976,
    "names": {
      "de": "Mongolei",
      "en": "Mongolia",
      "fi": "Mongolia",
      "fr": "Mongolie",
      "nl": "Mongolië",
      "sv": "Mongoliet"
    }
  },
  {
    "code": "MO",
    "countryCode": 853,
    "names": {
      "de": "Macao",
      "en": "Macao",
      "fi": "Macao",
      "fr": "Macao",
      "nl": "Macao",
      "sv": "Macao"
    }
  },
  {
    "code": "MP",
    "countryCode": 1,
    "names": {
      "de": "Nördliche Marianen",
      "en": "Northern Mariana Islands",
      "fi": "Pohjois-Mariaanit",
      "fr": "Îles Mariannes du Nord",
      "nl": "Noordelijke Marianeneilanden",
      "sv": "Nordmarianerna"
    }
  },
  {
    "code": "MQ",
    "countryCode": 596,
    "names": {
      "de": "Martinique",
      "en": "Martinique",
      "fi": "Martinique",
      "fr": "Martinique",
      "nl": "Martinique",
      "sv": "Martinique"
    }
  },
  {
    "code": "MR",
    "countryCode": 222,
    "names": {
      "de": "Mauretanien",
      "en": "Mauritania",
      "fi": "Mauritania",
      "fr": "Mauritanie",
      "nl": "Mauritanië",
      "sv": "Mauretanien"
    }
  },
  {
    "code": "MS",
    "countryCode": 1,
    "names": {
      "de": "Montserrat",
      "en": "Montserrat",
      "fi": "Montserrat",
      "fr": "Montserrat (Antilles)",
      "nl": "Montserrat",
      "sv": "Montserrat"
    }
  },
  {
    "code": "MT",
    "countryCode": 356,
    "names": {
      "de": "Malta",
      "en": "Malta",
      "fi": "Malta",
      "fr": "Malte",
      "nl": "Malta",
      "sv": "Malta"
    }
  },
  {
    "code": "MU",
    "countryCode": 230,
    "names": {
      "de": "Mauritius",
      "en": "Mauritius",
      "fi": "Mauritius",
      "fr": "Maurice",
      "nl": "Mauritius",
      "sv": "Mauritius"
    }
  },
  {
    "code": "MV",
    "countryCode": 960,
    "names": {
      "de": "Malediven",
      "en": "Maldives",
      "fi": "Malediivit",
      "fr": "Maldives",
      "nl": "Maldiven",
      "sv": "Maldiverna"
    }
  },
  {
    "code": "MW",
    "countryCode": 265,
    "names": {
      "de": "Malawi",
      "en": "Malawi",
      "fi": "Malawi",
      "fr": "Malawi",
      "nl": "Malawi",
      "sv": "Malawi"
    }
  },
  {
    "code": "MX",
    "countryCode": 52,
    "names": {
      "de": "Mexiko",
      "en": "Mexico",
      "fi": "Meksiko",
      "fr": "Mexique",
      "nl": "Mexico",
      "sv": "Mexiko"
    }
  },
  {
    "code": "MY",
    "countryCode": 60,
    "names": {
      "de": "Malaysia",
      "en": "Malaysia",
      "fi": "Malesia",
      "fr": "Malaisie",
      "nl": "Maleisië",
      "sv": "Malaysia"
    }
  },
  {
    "code": "MZ",
    "countryCode": 258,
    "names": {
      "de": "Mosambik",
      "en": "Mozambique",
      "fi": "Mosambik",
      "fr": "Mozambique",
      "nl": "Mozambique",
      "sv": "Moçambique"
    }
  },
  {
    "code": "NA",
    "countryCode": 264,
    "names": {
      "de": "Namibia",
      "en": "Namibia",
      "fi": "Namibia",
      "fr": "Namibie",
      "nl": "Namibië",
      "sv": "Namibia"
    }
  },
  {
    "code": "NC",
    "countryCode": 687,
    "names": {
      "de": "Neukaledonien",
      "en": "New Caledonia",
      "fi": "Uusi-Kaledonia",
      "fr": "Nouvelle-Calédonie",
      "nl": "Nieuw-Caledonië",
      "sv": "Nya Kaledonien"
    }
  },
  {
    "code": "NE",
    "countryCode": 227,
    "names": {
      "de": "Niger",
      "en": "Niger",
      "fi": "Niger",
      "fr": "Niger",
      "nl": "Niger",
      "sv": "Niger"
    }
  },
  {
    "code": "NF",
    "countryCode": 672,
    "names": {
      "de": "Norfolkinsel",
      "en": "Norfolk Island",
      "fi": "Norfolkinsaari",
      "fr": "Île Norfolk",
      "nl": "Norfolkeiland",
      "sv": "Norfolköarna"
    }
  },
  {
    "code": "NG",
    "countryCode": 234,
    "names": {
      "de": "Nigeria",
      "en": "Nigeria",
      "fi": "Nigeria",
      "fr": "Nigeria",
      "nl": "Nigeria",
      "sv": "Nigeria"
    }
  },
  {
    "code": "NI",
    "countryCode": 505,
    "names": {
      "de": "Nicaragua",
      "en": "Nicaragua",
      "fi": "Nicaragua",
      "fr": "Nicaragua",
      "nl": "Nicaragua",
      "sv": "Nicaragua"
    }
  },
  {
    "code": "NL",
    "countryCode": 31,
    "names": {
      "de": "Niederlande",
      "en": "Netherlands",
      "fi": "Alankomaat",
      "fr": "Pays-Bas",
      "nl": "Nederland",
      "sv": "Nederländerna"
    }
  },
  {
    "code": "NO",
    "countryCode": 47,
    "names": {
      "de": "Norwegen",
      "en": "Norway",
      "fi": "Norja",
      "fr": "Norvège",
      "nl": "Noorwegen",
      "sv": "Norge"
    }
  },
  {
    "code": "NP",
    "countryCode": 977,
    "names": {
      "de": "Nepal",
      "en": "Nepal",
      "fi": "Nepal",
      "fr": "Népal",
      "nl": "Nepal",
      "sv": "Nepal"
    }
  },
  {
    "code": "NR",
    "countryCode": 674,
    "names": {
      "de": "Nauru",
      "en": "Nauru",
      "fi": "Nauru",
      "fr": "Nauru",
      "nl": "Nauru",
      "sv": "Nauru"
    }
  },
  {
    "code": "NU",
    "countryCode": 683,
    "names": { "de": "Niue", "en": "Niue", "fi": "Niue", "fr": "Niue", "nl": "Niue", "sv": "Niue" }
  },
  {
    "code": "NZ",
    "countryCode": 64,
    "names": {
      "de": "Neuseeland",
      "en": "New Zealand",
      "fi": "Uusi-Seelanti",
      "fr": "Nouvelle-Zélande",
      "nl": "Nieuw-Zeeland",
      "sv": "Nya Zeeland"
    }
  },
  {
    "code": "OM",
    "countryCode": 968,
    "names": { "de": "Oman", "en": "Oman", "fi": "Oman", "fr": "Oman", "nl": "Oman", "sv": "Oman" }
  },
  {
    "code": "PA",
    "countryCode": 507,
    "names": {
      "de": "Panama",
      "en": "Panama",
      "fi": "Panama",
      "fr": "Panama",
      "nl": "Panama",
      "sv": "Panama"
    }
  },
  {
    "code": "PE",
    "countryCode": 51,
    "names": { "de": "Peru", "en": "Peru", "fi": "Peru", "fr": "Pérou", "nl": "Peru", "sv": "Peru" }
  },
  {
    "code": "PF",
    "countryCode": 689,
    "names": {
      "de": "Französisch-Polynesien",
      "en": "French Polynesia",
      "fi": "Ranskan Polynesia",
      "fr": "Polynésie française",
      "nl": "Frans-Polynesië",
      "sv": "Franska Polynesien"
    }
  },
  {
    "code": "PG",
    "countryCode": 675,
    "names": {
      "de": "Papua-Neuguinea",
      "en": "Papua New Guinea",
      "fi": "Papua-Uusi-Guinea",
      "fr": "Papouasie-Nouvelle-Guinée",
      "nl": "Papoea-Nieuw-Guinea",
      "sv": "Papua Nya Guinea"
    }
  },
  {
    "code": "PH",
    "countryCode": 63,
    "names": {
      "de": "Philippinen",
      "en": "Philippines",
      "fi": "Filippiinit",
      "fr": "Philippines",
      "nl": "Filipijnen",
      "sv": "Filippinerna"
    }
  },
  {
    "code": "PK",
    "countryCode": 92,
    "names": {
      "de": "Pakistan",
      "en": "Pakistan",
      "fi": "Pakistan",
      "fr": "Pakistan",
      "nl": "Pakistan",
      "sv": "Pakistan"
    }
  },
  {
    "code": "PL",
    "countryCode": 48,
    "names": {
      "de": "Polen",
      "en": "Poland",
      "fi": "Puola",
      "fr": "Pologne",
      "nl": "Polen",
      "sv": "Polen"
    }
  },
  {
    "code": "PM",
    "countryCode": 508,
    "names": {
      "de": "Saint-Pierre und Miquelon",
      "en": "Saint Pierre and Miquelon",
      "fi": "Saint-Pierre ja Miquelon",
      "fr": "Saint-Pierre-et-Miquelon",
      "nl": "Saint Pierre en Miquelon",
      "sv": "Sankt Pierre och Miquelon"
    }
  },
  {
    "code": "PN",
    "countryCode": 0,
    "names": {
      "de": "Pitcairninseln",
      "en": "Pitcairn",
      "fi": "Pitcairn",
      "fr": "Île Pitcairn",
      "nl": "Pitcairn",
      "sv": "Pitcairn"
    }
  },
  {
    "code": "PR",
    "countryCode": 1,
    "names": {
      "de": "Puerto Rico",
      "en": "Puerto Rico",
      "fi": "Puerto Rico",
      "fr": "Porto Rico",
      "nl": "Puerto Rico",
      "sv": "Puerto Rico"
    }
  },
  {
    "code": "PS",
    "countryCode": 970,
    "names": {
      "de": "Palästinensische Autonomiegebiete",
      "en": "Palestine, State of",
      "fi": "Palestine, State of",
      "fr": "Territoires Palestiniens",
      "nl": "Palestijns Gebied",
      "sv": "Staten Palestina"
    }
  },
  {
    "code": "PT",
    "countryCode": 351,
    "names": {
      "de": "Portugal",
      "en": "Portugal",
      "fi": "Portugali",
      "fr": "Portugal",
      "nl": "Portugal",
      "sv": "Portugal"
    }
  },
  {
    "code": "PW",
    "countryCode": 680,
    "names": {
      "de": "Palau",
      "en": "Palau",
      "fi": "Palau",
      "fr": "Palaos",
      "nl": "Palau",
      "sv": "Palau"
    }
  },
  {
    "code": "PY",
    "countryCode": 595,
    "names": {
      "de": "Paraguay",
      "en": "Paraguay",
      "fi": "Paraguay",
      "fr": "Paraguay",
      "nl": "Paraguay",
      "sv": "Paraguay"
    }
  },
  {
    "code": "QA",
    "countryCode": 974,
    "names": {
      "de": "Katar",
      "en": "Qatar",
      "fi": "Qatar",
      "fr": "Qatar",
      "nl": "Qatar",
      "sv": "Qatar"
    }
  },
  {
    "code": "RE",
    "countryCode": 262,
    "names": {
      "de": "Réunion",
      "en": "Réunion",
      "fi": "Réunion",
      "fr": "La Réunion",
      "nl": "Réunion",
      "sv": "Réunion"
    }
  },
  {
    "code": "RO",
    "countryCode": 40,
    "names": {
      "de": "Rumänien",
      "en": "Romania",
      "fi": "Romania",
      "fr": "Roumanie",
      "nl": "Roemenië",
      "sv": "Rumänien"
    }
  },
  {
    "code": "RS",
    "countryCode": 381,
    "names": {
      "de": "Serbien",
      "en": "Serbia",
      "fi": "Serbia",
      "fr": "Serbie",
      "nl": "Servië",
      "sv": "Serbien"
    }
  },
  {
    "code": "RU",
    "countryCode": 7,
    "names": {
      "de": "Russische Föderation",
      "en": "Russia",
      "fi": "Venäjän federaatio",
      "fr": "Russie",
      "nl": "Rusland",
      "sv": "Ryska federationen"
    }
  },
  {
    "code": "RW",
    "countryCode": 250,
    "names": {
      "de": "Ruanda",
      "en": "Rwanda",
      "fi": "Ruanda",
      "fr": "Rwanda",
      "nl": "Rwanda",
      "sv": "Rwanda"
    }
  },
  {
    "code": "SA",
    "countryCode": 966,
    "names": {
      "de": "Saudi-Arabien",
      "en": "Saudi Arabia",
      "fi": "Saudi-Arabia",
      "fr": "Arabie saoudite",
      "nl": "Saoedi-Arabië",
      "sv": "Saudiarabien"
    }
  },
  {
    "code": "SB",
    "countryCode": 677,
    "names": {
      "de": "Salomonen",
      "en": "Solomon Islands",
      "fi": "Salomonsaaret",
      "fr": "Îles Salomon",
      "nl": "Salomonseilanden",
      "sv": "Salomonöarna"
    }
  },
  {
    "code": "SC",
    "countryCode": 248,
    "names": {
      "de": "Seychellen",
      "en": "Seychelles",
      "fi": "Seychellit",
      "fr": "Seychelles",
      "nl": "Seychellen",
      "sv": "Seychellerna"
    }
  },
  {
    "code": "SD",
    "countryCode": 249,
    "names": {
      "de": "Sudan",
      "en": "Sudan",
      "fi": "Sudan",
      "fr": "Soudan",
      "nl": "Soedan",
      "sv": "Sudan"
    }
  },
  {
    "code": "SE",
    "countryCode": 46,
    "names": {
      "de": "Schweden",
      "en": "Sweden",
      "fi": "Ruotsi",
      "fr": "Suède",
      "nl": "Zweden",
      "sv": "Sverige"
    }
  },
  {
    "code": "SG",
    "countryCode": 65,
    "names": {
      "de": "Singapur",
      "en": "Singapore",
      "fi": "Singapore",
      "fr": "Singapour",
      "nl": "Singapore",
      "sv": "Singapore"
    }
  },
  {
    "code": "SH",
    "countryCode": 290,
    "names": {
      "de": "St. Helena",
      "en": "Saint Helena, Ascension and Tristan da Cunha",
      "fi": "Saint Helena, Ascension ja Tristan da Cunha",
      "fr": "Sainte-Hélène, Ascension et Tristan da Cunha",
      "nl": "Sint-Helena",
      "sv": "Saint Helena, Ascension och Tristan da Cunha"
    }
  },
  {
    "code": "SI",
    "countryCode": 386,
    "names": {
      "de": "Slowenien",
      "en": "Slovenia",
      "fi": "Slovenia",
      "fr": "Slovénie",
      "nl": "Slovenië",
      "sv": "Slovenien"
    }
  },
  {
    "code": "SJ",
    "countryCode": 47,
    "names": {
      "de": "Svalbard und Jan Mayen",
      "en": "Svalbard and Jan Mayen",
      "fi": "Svalbard ja Jan Mayen",
      "fr": "Svalbard et Jan Mayen",
      "nl": "Svalbard en Jan Mayen",
      "sv": "Svalbard och Jan Mayen"
    }
  },
  {
    "code": "SK",
    "countryCode": 421,
    "names": {
      "de": "Slowakei",
      "en": "Slovakia",
      "fi": "Slovakia",
      "fr": "Slovaquie",
      "nl": "Slowakije",
      "sv": "Slovakien"
    }
  },
  {
    "code": "SL",
    "countryCode": 232,
    "names": {
      "de": "Sierra Leone",
      "en": "Sierra Leone",
      "fi": "Sierra Leone",
      "fr": "Sierra Leone",
      "nl": "Sierra Leone",
      "sv": "Sierra Leone"
    }
  },
  {
    "code": "SM",
    "countryCode": 378,
    "names": {
      "de": "San Marino",
      "en": "San Marino",
      "fi": "San Marino",
      "fr": "Saint-Marin",
      "nl": "San Marino",
      "sv": "San Marino"
    }
  },
  {
    "code": "SN",
    "countryCode": 221,
    "names": {
      "de": "Senegal",
      "en": "Senegal",
      "fi": "Senegal",
      "fr": "Sénégal",
      "nl": "Senegal",
      "sv": "Senegal"
    }
  },
  {
    "code": "SO",
    "countryCode": 252,
    "names": {
      "de": "Somalia",
      "en": "Somalia",
      "fi": "Somalia",
      "fr": "Somalie",
      "nl": "Somalië",
      "sv": "Somalia"
    }
  },
  {
    "code": "SR",
    "countryCode": 597,
    "names": {
      "de": "Suriname",
      "en": "Suriname",
      "fi": "Suriname",
      "fr": "Suriname",
      "nl": "Suriname",
      "sv": "Surinam"
    }
  },
  {
    "code": "SS",
    "countryCode": 211,
    "names": {
      "de": "Südsudan",
      "en": "South Sudan",
      "fi": "Etelä-Sudan",
      "fr": "Soudan du Sud",
      "nl": "Zuid-Soedan",
      "sv": "Sydsudan"
    }
  },
  {
    "code": "ST",
    "countryCode": 239,
    "names": {
      "de": "São Tomé und Príncipe",
      "en": "Sao Tome and Principe",
      "fi": "São Tomé ja Príncipe",
      "fr": "Sao Tomé-et-Principe",
      "nl": "Sao Tomé en Principe",
      "sv": "São Tomé och Príncipe"
    }
  },
  {
    "code": "SV",
    "countryCode": 503,
    "names": {
      "de": "El Salvador",
      "en": "El Salvador",
      "fi": "El Salvador",
      "fr": "Salvador",
      "nl": "El Salvador",
      "sv": "El Salvador"
    }
  },
  {
    "code": "SX",
    "countryCode": 1,
    "names": {
      "de": "Sint Maarten",
      "en": "Sint Maarten (Dutch part)",
      "fi": "Sint Maarten (hollantilainen osa)",
      "fr": "Saint-Martin (Royaume des Pays-Bas)",
      "nl": "Sint Maarten (Nederlands deel)",
      "sv": "Sint Maarten (nederländska delen)"
    }
  },
  {
    "code": "SY",
    "countryCode": 963,
    "names": {
      "de": "Syrien, Arabische Republik",
      "en": "Syrian Arab Republic",
      "fi": "Syyrian arabitasavalta",
      "fr": "Syrie",
      "nl": "Syrië",
      "sv": "Syriska arabrepubliken"
    }
  },
  {
    "code": "SZ",
    "countryCode": 268,
    "names": {
      "de": "Swasiland",
      "en": "Swaziland",
      "fi": "Swaziland",
      "fr": "Swaziland",
      "nl": "Swaziland",
      "sv": "Swaziland"
    }
  },
  {
    "code": "TC",
    "countryCode": 1,
    "names": {
      "de": "Turks- und Caicosinseln",
      "en": "Turks and Caicos Islands",
      "fi": "Turks- ja Caicossaaret",
      "fr": "Îles Turques-et-Caïques",
      "nl": "Turks- en Caicoseilanden",
      "sv": "Turks- och Caicosöarna"
    }
  },
  {
    "code": "TD",
    "countryCode": 235,
    "names": {
      "de": "Tschad",
      "en": "Chad",
      "fi": "Tšad",
      "fr": "Tchad",
      "nl": "Tsjaad",
      "sv": "Tchad"
    }
  },
  {
    "code": "TF",
    "countryCode": 0,
    "names": {
      "de": "Französische Süd- und Antarktisgebiete",
      "en": "French Southern Territories",
      "fi": "Ranskan eteläiset alueet",
      "fr": "Terres australes et antarctiques françaises",
      "nl": "Franse Gebieden in de zuidelijke Indische Oceaan",
      "sv": "Franska sydterritorierna"
    }
  },
  {
    "code": "TG",
    "countryCode": 228,
    "names": { "de": "Togo", "en": "Togo", "fi": "Togo", "fr": "Togo", "nl": "Togo", "sv": "Togo" }
  },
  {
    "code": "TH",
    "countryCode": 66,
    "names": {
      "de": "Thailand",
      "en": "Thailand",
      "fi": "Thaimaa",
      "fr": "Thaïlande",
      "nl": "Thailand",
      "sv": "Thailand"
    }
  },
  {
    "code": "TJ",
    "countryCode": 992,
    "names": {
      "de": "Tadschikistan",
      "en": "Tajikistan",
      "fi": "Tadžikistan",
      "fr": "Tadjikistan",
      "nl": "Tadzjikistan",
      "sv": "Tadzjikistan"
    }
  },
  {
    "code": "TK",
    "countryCode": 690,
    "names": {
      "de": "Tokelau",
      "en": "Tokelau",
      "fi": "Tokelau",
      "fr": "Tokelau",
      "nl": "Tokelau",
      "sv": "Tokelau"
    }
  },
  {
    "code": "TL",
    "countryCode": 670,
    "names": {
      "de": "Osttimor (Timor-Leste)",
      "en": "Timor-Leste",
      "fi": "Itä-Timor",
      "fr": "Timor-Oriental",
      "nl": "Oost-Timor",
      "sv": "Östtimor"
    }
  },
  {
    "code": "TM",
    "countryCode": 993,
    "names": {
      "de": "Turkmenistan",
      "en": "Turkmenistan",
      "fi": "Turkmenistan",
      "fr": "Turkménistan",
      "nl": "Turkmenistan",
      "sv": "Turkmenistan"
    }
  },
  {
    "code": "TN",
    "countryCode": 216,
    "names": {
      "de": "Tunesien",
      "en": "Tunisia",
      "fi": "Tunisia",
      "fr": "Tunisie",
      "nl": "Tunesië",
      "sv": "Tunisien"
    }
  },
  {
    "code": "TO",
    "countryCode": 676,
    "names": {
      "de": "Tonga",
      "en": "Tonga",
      "fi": "Tonga",
      "fr": "Tonga",
      "nl": "Tonga",
      "sv": "Tonga"
    }
  },
  {
    "code": "TR",
    "countryCode": 90,
    "names": {
      "de": "Türkei",
      "en": "Türkiye",
      "fi": "Turkki",
      "fr": "Turquie",
      "nl": "Turkije",
      "sv": "Turkiet"
    }
  },
  {
    "code": "TT",
    "countryCode": 1,
    "names": {
      "de": "Trinidad und Tobago",
      "en": "Trinidad and Tobago",
      "fi": "Trinidad ja Tobago",
      "fr": "Trinité-et-Tobago",
      "nl": "Trinidad en Tobago",
      "sv": "Trinidad och Tobago"
    }
  },
  {
    "code": "TV",
    "countryCode": 688,
    "names": {
      "de": "Tuvalu",
      "en": "Tuvalu",
      "fi": "Tuvalu",
      "fr": "Tuvalu",
      "nl": "Tuvalu",
      "sv": "Tuvalu"
    }
  },
  {
    "code": "TW",
    "countryCode": 886,
    "names": {
      "de": "Taiwan",
      "en": "Taiwan",
      "fi": "Taiwan, Kiinan provinssi",
      "fr": "Taïwan",
      "nl": "Taiwan",
      "sv": "Taiwan, provins i Kina"
    }
  },
  {
    "code": "TZ",
    "countryCode": 255,
    "names": {
      "de": "Tansania, Vereinigte Republik",
      "en": "Tanzania, United Republic of",
      "fi": "Tansanian yhdistynyt tasavalta",
      "fr": "Tanzanie",
      "nl": "Tanzania",
      "sv": "Tanzania, förenade republiken"
    }
  },
  {
    "code": "UA",
    "countryCode": 380,
    "names": {
      "de": "Ukraine",
      "en": "Ukraine",
      "fi": "Ukraina",
      "fr": "Ukraine",
      "nl": "Oekraïne",
      "sv": "Ukraina"
    }
  },
  {
    "code": "UG",
    "countryCode": 256,
    "names": {
      "de": "Uganda",
      "en": "Uganda",
      "fi": "Uganda",
      "fr": "Ouganda",
      "nl": "Oeganda",
      "sv": "Uganda"
    }
  },
  {
    "code": "UM",
    "countryCode": 0,
    "names": {
      "de": "United States Minor Outlying Islands",
      "en": "United States Minor Outlying Islands",
      "fi": "Yhdysvaltain pienet erillissaaret",
      "fr": "Îles mineures éloignées des États-Unis",
      "nl": "Amerikaanse kleinere afgelegen eilanden",
      "sv": "Förenta staternas mindre öar i Oceanien och Västindien"
    }
  },
  {
    "code": "US",
    "countryCode": 1,
    "names": {
      "de": "Vereinigte Staaten von Amerika",
      "en": "United States",
      "fi": "Yhdysvallat",
      "fr": "États-Unis",
      "nl": "Verenigde Staten",
      "sv": "USA"
    }
  },
  {
    "code": "UY",
    "countryCode": 598,
    "names": {
      "de": "Uruguay",
      "en": "Uruguay",
      "fi": "Uruguay",
      "fr": "Uruguay",
      "nl": "Uruguay",
      "sv": "Uruguay"
    }
  },
  {
    "code": "UZ",
    "countryCode": 998,
    "names": {
      "de": "Usbekistan",
      "en": "Uzbekistan",
      "fi": "Uzbekistan",
      "fr": "Ouzbékistan",
      "nl": "Oezbekistan",
      "sv": "Uzbekistan"
    }
  },
  {
    "code": "VA",
    "countryCode": 39,
    "names": {
      "de": "Vatikanstadt",
      "en": "Holy See (Vatican City State)",
      "fi": "Pyhä istuin (Vatikaanivaltio)",
      "fr": "Vatican",
      "nl": "Vaticaanstad, Staat",
      "sv": "Vatikanstaten"
    }
  },
  {
    "code": "VC",
    "countryCode": 1,
    "names": {
      "de": "St. Vincent und die Grenadinen",
      "en": "Saint Vincent and the Grenadines",
      "fi": "Saint Vincent ja Grenadiinit",
      "fr": "Saint-Vincent-et-les-Grenadines",
      "nl": "Saint Vincent en de Grenadines",
      "sv": "Sankt Vincent och Grenadinerna"
    }
  },
  {
    "code": "VE",
    "countryCode": 58,
    "names": {
      "de": "Venezuela",
      "en": "Venezuela, Bolivarian Republic of",
      "fi": "Venezuelan bolivariaanien tasavalta",
      "fr": "Vénézuéla",
      "nl": "Venezuela",
      "sv": "Venezuela, Bolivarianska republiken"
    }
  },
  {
    "code": "VG",
    "countryCode": 1,
    "names": {
      "de": "Britische Jungferninseln",
      "en": "Virgin Islands, British",
      "fi": "Neitsytsaaret, Brittiläiset",
      "fr": "Îles Vierges britanniques",
      "nl": "Britse Maagdeneilanden",
      "sv": "Jungfruöarna, brittiska"
    }
  },
  {
    "code": "VI",
    "countryCode": 1,
    "names": {
      "de": "Amerikanische Jungferninseln",
      "en": "Virgin Islands, U.S.",
      "fi": "Neitsytsaaret, Yhdysvaltain",
      "fr": "Îles Vierges, États-Unis",
      "nl": "Maagdeneilanden, Amerikaanse",
      "sv": "Jungfruöarna, amerikanska"
    }
  },
  {
    "code": "VN",
    "countryCode": 84,
    "names": {
      "de": "Vietnam",
      "en": "Vietnam",
      "fi": "Vietnam",
      "fr": "Viêt Nam",
      "nl": "Vietnam",
      "sv": "Vietnam"
    }
  },
  {
    "code": "VU",
    "countryCode": 678,
    "names": {
      "de": "Vanuatu",
      "en": "Vanuatu",
      "fi": "Vanuatu",
      "fr": "Vanuatu",
      "nl": "Vanuatu",
      "sv": "Vanuatu"
    }
  },
  {
    "code": "WF",
    "countryCode": 681,
    "names": {
      "de": "Wallis und Futuna",
      "en": "Wallis and Futuna",
      "fi": "Wallis ja Futuna",
      "fr": "Wallis-et-Futuna",
      "nl": "Wallis en Futuna",
      "sv": "Wallis och Futuna"
    }
  },
  {
    "code": "WS",
    "countryCode": 685,
    "names": {
      "de": "Samoa",
      "en": "Samoa",
      "fi": "Samoa",
      "fr": "Samoa",
      "nl": "Samoa",
      "sv": "Samoa"
    }
  },
  {
    "code": "XK",
    "countryCode": 383,
    "names": {
      "de": "Kosovo",
      "en": "Kosovo",
      "fi": "Kosovo",
      "fr": "Kosovo",
      "nl": "Kosovo",
      "sv": "Kosovo"
    }
  },
  {
    "code": "YE",
    "countryCode": 967,
    "names": {
      "de": "Jemen",
      "en": "Yemen",
      "fi": "Jemen",
      "fr": "Yemen",
      "nl": "Jemen",
      "sv": "Yemen"
    }
  },
  {
    "code": "YT",
    "countryCode": 262,
    "names": {
      "de": "Mayotte",
      "en": "Mayotte",
      "fi": "Mayotte",
      "fr": "Mayotte",
      "nl": "Mayotte",
      "sv": "Mayotte"
    }
  },
  {
    "code": "ZA",
    "countryCode": 27,
    "names": {
      "de": "Südafrika",
      "en": "South Africa",
      "fi": "Etelä-Afrikka",
      "fr": "Afrique du Sud",
      "nl": "Zuid-Afrika",
      "sv": "Sydafrika"
    }
  },
  {
    "code": "ZM",
    "countryCode": 260,
    "names": {
      "de": "Sambia",
      "en": "Zambia",
      "fi": "Sambia",
      "fr": "Zambie",
      "nl": "Zambia",
      "sv": "Zambia"
    }
  },
  {
    "code": "ZW",
    "countryCode": 263,
    "names": {
      "de": "Simbabwe",
      "en": "Zimbabwe",
      "fi": "Zimbabwe",
      "fr": "Zimbabwe",
      "nl": "Zimbabwe",
      "sv": "Zimbabwe"
    }
  }
]
